module.exports = __webpack_public_path__ + "img/logo.3680bd99.png";